export default "__VITE_ASSET__DzAz_Hqn__"